import React from 'react';
import {
    Flex,
    Tab,
    Tabs,
    TabPanels,
    TabPanel,
    TabList,
    Grid,
    GridItem,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    TableContainer,
    TableCaption,
    Text,
    useMediaQuery,
    useTheme,

} from '@chakra-ui/react';
import { list } from '../resource';
import TableMobile from './TableMobile';

const Planes = () => {
    const { breakpoints } = useTheme();
    const [isGreaterThanMd] = useMediaQuery(`(min-width: ${breakpoints.md})`);

    return (
        <Flex
            color='rgba(84, 84, 84, 1)'
            width='100%'
            id='planes-pago'
            mb={40}
        >
            <Grid
                templateColumns={"repeat(1, 1fr)"}
                w={"100%"}
                pl={"12%"}
                pt={isGreaterThanMd ? 10 : 0}
            >
                <GridItem w="90%">
                    <Flex flexDirection={"column"} mb={"1rem"} mt={0}>
                        <Flex justifyContent={"center"}>
                            <Text
                                textTransform={"uppercase"}
                                lineHeight={'89.2px'}
                                fontWeight={700}
                                fontSize={isGreaterThanMd ? "50px" : "25px"}
                                color='rgba(84, 84, 84, 1)'
                            >
                                Planes de pago
                            </Text>
                        </Flex>
                    </Flex>
                    {isGreaterThanMd ?
                        <Tabs variant='enclosed'>
                            <TabList width={"100%"} justifyContent={'center'} fontFamily='Shne-Breit-Regular'>
                                <Tab id='tab1' fontSize={'22px'} _selected={{ bg: 'rgba(172, 255, 197, 1)', color: "#000000", fontWeight: "600", fontSize: '22px', fontFamily: 'Shne-Breit-Halbfett' }}>Contado</Tab>
                                <Tab id='tab2' fontSize={'22px'} _selected={{ bg: 'rgba(172, 255, 197, 1)', color: "#000000", fontWeight: "600", fontSize: '22px', fontFamily: 'Shne-Breit-Halbfett' }}>Contado comercial</Tab>
                                <Tab id='tab3' fontSize={'22px'} _selected={{ bg: 'rgba(172, 255, 197, 1)', color: "#000000", fontWeight: "600", fontSize: '22px', fontFamily: 'Shne-Breit-Halbfett' }}>6 meses</Tab>
                                <Tab id='tab4' fontSize={'22px'} _selected={{ bg: 'rgba(172, 255, 197, 1)', color: "#000000", fontWeight: "600", fontSize: '22px', fontFamily: 'Shne-Breit-Halbfett' }}>12 meses</Tab>
                                <Tab id='tab5' fontSize={'22px'} _selected={{ bg: 'rgba(172, 255, 197, 1)', color: "#000000", fontWeight: "600", fontSize: '22px', fontFamily: 'Shne-Breit-Halbfett' }}>*Politica especial</Tab>
                            </TabList>
                            <TabPanels>
                                {list.map((item, idx) => (
                                    <TabPanel key={idx}>
                                        <TableContainer>
                                            <Table size='lg' >
                                                <TableCaption
                                                    mt={40}
                                                    fontFamily='Shne-Breit-Extraleicht'
                                                    fontSize={"14px"}
                                                >
                                                    *Pol&iacute;tica Comercial sujeta a cambio sin previo aviso y
                                                    sujeto a disponibilidad.
                                                </TableCaption>
                                                <Thead>
                                                    <Tr>
                                                        <Th
                                                            color={"#000000"}
                                                            fontSize={'20px'}
                                                            textTransform={"inherit"}
                                                            fontFamily='Shne-Breit-Bold'
                                                        >
                                                            Descuento
                                                        </Th>
                                                        <Th
                                                            color={"#000000"}
                                                            fontSize={'20px'}
                                                            fontFamily='Shne-Breit-Bold'
                                                        >
                                                            {item.num}
                                                        </Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    <Tr>
                                                        <Th
                                                            borderColor={'white'}
                                                            fontSize={'20px'}
                                                            fontFamily='Shne-Breit-Bold'
                                                        >
                                                            {item.pay}
                                                        </Th>

                                                    </Tr>
                                                    {item.tab.map((element, idx) => (
                                                        <Tr>
                                                            <Th
                                                                borderColor={'white'}
                                                                textTransform={"inherit"}
                                                                fontSize={'19px'}
                                                                fontFamily='Shne-Breit-Extraleicht'
                                                            >
                                                                {element.item1}
                                                            </Th>
                                                            <Th
                                                                borderColor={'white'}
                                                                textTransform={"inherit"}
                                                                fontSize={'19px'}
                                                                fontFamily='Shne-Breit-Extraleicht'
                                                            >
                                                                {element.item2}</Th>
                                                        </Tr>
                                                    ))}
                                                </Tbody>
                                            </Table>
                                        </TableContainer>
                                    </TabPanel>
                                ))}
                            </TabPanels>
                        </Tabs> : <TableMobile />
                    }
                </GridItem>
            </Grid>
        </Flex>
    );
}

export default Planes;
